export function IconStar({ filled }: Readonly<{ filled: boolean }>) {
  return (
    <svg className={`w-7 md:h-8 md:w-8 ${filled ? 'text-gray-800' : 'text-gray-200'}`} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 1.5L15.09 8.76L23 9.52L17 14.7L18.8 22.5L12 18.45L5.2 22.5L7 14.7L1 9.52L8.91 8.76L12 1.5Z" />
    </svg>
  );
}
